import { isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      header: {
        minHeight: '56px',
        paddingBlockEnd: tokens.spacingGap200,
        paddingBlockStart: tokens.spacingGap400,
        paddingInlineStart: tokens.spacingGap400,
        paddingInlineEnd: tokens.spacingGap700,

        [isPhoneInLandscape]: {
          paddingBlockStart: tokens.spacingGap300,
          paddingInlineStart: tokens.spacingGap200,
          paddingInlineEnd: tokens.spacingGap600,

          h2: {
            ...tokens.fontHeadingXS,
          },
        },
      },
    },
  } as const
}
